import type { CreateOverlayReturn } from "@chakra-ui/react";

type OverlayInstance = { onOpenChange?: (e: { open: boolean }) => void };

export const closeAllOverlayInstances = (
  overlay: Pick<CreateOverlayReturn<any>, "getSnapshot">,
) => {
  (overlay.getSnapshot() as OverlayInstance[]).forEach((instance) => {
    instance.onOpenChange?.({ open: false });
  });
};
